import { IStyleFunctionOrObject } from '@fluentui/react'
import { ITextFieldStyleProps, ITextFieldStyles, TextField } from '@fluentui/react/lib/TextField'
import _ from 'lodash'
import { IStringValue } from 'model/FlexibleAttributeModel'
import React from 'react'

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: IStringValue) => void;
    defaultFieldValue?: IStringValue;
    styles?: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>
}

const styleProps: Partial<ITextFieldStyles> = {
    field: {
        fontWeight: 'bold'
    }
}

const Multiline: React.FC<IProps> = (props) => {

    const { handleChange, defaultValue, disabled } = props

    //TODO useMemo, in case of rerender(controlled component) this debounce will be gone!
    const fieldValueOnChange = _.debounce(
        (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
            const value: IStringValue = {
                type: 'string',
                value: newValue!
            }
            props.fieldValueOnChange?.(event, value);
        }, 410);

    return (
        <TextField
            onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
            defaultValue={props.defaultFieldValue ? props.defaultFieldValue.value : defaultValue}
            disabled={disabled}
            multiline
            autoAdjustHeight
            maxLength={4000}
            styles={props.styles ?? styleProps}
        />
    )
}

export default Multiline